import { dadosIniciaisAcompanhamentoEmTempoReal } from '../utils.js'

const nomes = ['Ana', 'Bruno', 'Carla', 'Diego', 'Elisa', 'Felipe', 'Gabriela', 'Henrique', 'Isabela', 'Joao']
const sobrenomes = ['Almeida', 'Barbosa', 'Costa', 'Dias', 'Esteves', 'Freitas', 'Gomes', 'Lima', 'Mendes', 'Rocha']
const locaisDeTrabalho = [
  { nome: 'Centro Aurora', empregador: 'Grupo Aurora' },
  { nome: 'Estacao Aurora', empregador: 'Grupo Aurora' },
  { nome: 'Atelie Aurora', empregador: 'Grupo Aurora' },
  { nome: 'Hub Nebula', empregador: 'Empresas Nebula' },
  { nome: 'Base Nebula', empregador: 'Empresas Nebula' },
  { nome: 'Unidade Nebula Sul', empregador: 'Empresas Nebula' },
  { nome: 'Praca Vale', empregador: 'Rede Vale' },
  { nome: 'Estacao Vale', empregador: 'Rede Vale' },
  { nome: 'Unidade Vale Oeste', empregador: 'Rede Vale' },
  { nome: 'Centro Vale Norte', empregador: 'Rede Vale' },
]

const dataAtual = new Date().toISOString().slice(0, 10)
const horario = (valor) => `${dataAtual}T${valor}:00`

const funcionarios = Array.from({ length: 100 }, (_, indice) => {
  const local = locaisDeTrabalho[indice % locaisDeTrabalho.length]
  const inicioJornada = indice % 3 === 0 ? '09:00' : '08:00'
  const fimJornada = indice % 3 === 0 ? '18:00' : '17:00'

  return {
    id: `demo-${String(indice + 1).padStart(3, '0')}`,
    nome: `${nomes[indice % nomes.length]} ${sobrenomes[Math.floor(indice / nomes.length)]}`,
    localDeTrabalho: local.nome,
    empregador: local.empregador,
    entradaPrevista: horario(inicioJornada),
    entradaBatida: indice >= 79 && indice < 84 ? horario('08:12') : horario(inicioJornada),
    horarioLimite: indice >= 75 && indice < 79 ? horario('17:30') : undefined,
    saidaPrevista: indice >= 73 && indice < 79 ? horario(fimJornada) : undefined,
    saidaBatida: indice >= 87 && indice < 92 ? horario('17:05') : undefined,
  }
})

const porId = Object.fromEntries(funcionarios.map(funcionario => [funcionario.id, funcionario]))
const grupo = (ids) => ({ total: ids.length, funcionarios: ids.map(id => porId[id]) })
const ids = (inicio, fim) => funcionarios.slice(inicio, fim).map(funcionario => funcionario.id)

function criarDadosDemonstrativos () {
  const dados = JSON.parse(JSON.stringify(dadosIniciaisAcompanhamentoEmTempoReal))
  dados.estados.trabalhando = grupo(ids(0, 61))
  dados.estados.emPausa = grupo(ids(61, 67))
  dados.estados.aRetornarEmBreve = grupo(ids(67, 69))
  dados.estados.retornoPausaEmAtraso = grupo(ids(69, 70))
  dados.estados.aSairEmBreve = grupo(ids(70, 73))
  dados.estados.emHoraExtra = grupo(ids(73, 75))
  dados.estados.aEstourarLimiteDeHoraExtraEmBreve = grupo(ids(75, 77))
  dados.estados.aEstourarLimiteDeHoraExtraEmBreve15min = grupo(ids(77, 78))
  dados.estados.realizandoHoraExtraAcimaDoLimiteDefinido = grupo(ids(78, 79))
  dados.estados.emAtraso = grupo(ids(79, 84))
  dados.estados.aEntrarEmBreve = grupo(ids(84, 86))
  dados.estados.antesDeTrabalhar = grupo(ids(86, 87))
  dados.estados.trabalhou = grupo(ids(87, 92))
  dados.estados.faltou = grupo(ids(92, 94))
  dados.eventos.entradaAtrasada = grupo(ids(79, 84))
  dados.eventos.ausencias.ferias = grupo(ids(94, 97))
  dados.eventos.ausencias.dispensa = grupo(ids(97, 98))
  dados.eventos.ausencias.afastamento = grupo(ids(98, 99))
  dados.eventos.ausencias.folga = grupo(ids(99, 100))
  return dados
}

function pontosDoFuncionario (funcionarioId) {
  const horarios = funcionarioId === 'demo-080'
    ? [horario('08:12'), horario('12:00'), horario('13:00'), horario('17:00')]
    : [horario('08:00'), horario('12:00'), horario('13:00'), horario('17:00')]
  return horarios.map((time, index) => [{ id: `${funcionarioId}-ponto-${index}`, time }])
}

export const fonteDeDadosDemonstrativos = {
  async buscarAcompanhamento () {
    return {
      total_de_empregados: funcionarios.length,
      ...criarDadosDemonstrativos(),
    }
  },
  async buscarDetalhesDoFuncionario (funcionarioId) {
    const funcionario = porId[funcionarioId]
    if (!funcionario) return {}
    return {
      ...funcionario,
      name: funcionario.nome,
      email: `${funcionario.nome.toLowerCase().replace(' ', '.')}@exemplo.com`,
      code: funcionario.id,
      company: [{ name: funcionario.empregador }],
      funct: 'Analista',
      routine: { name: '08:00 - 17:00' },
    }
  },
  async buscarPontosDoFuncionario (funcionarioId) {
    return porId[funcionarioId] ? pontosDoFuncionario(funcionarioId) : []
  },
  async buscarJornadaDoFuncionario (funcionarioId) {
    if (!porId[funcionarioId]) return {}
    return {
      entrada: horario('08:00'),
      saida: horario('17:00'),
      inicioIntervalo: horario('12:00'),
      fimIntervalo: horario('13:00'),
    }
  },
}
